import { Injectable } from '@angular/core';
import { IDataset } from '../../model/datasets/dataset';
import _ from 'lodash';
import { FastqQcStatus } from '../../model/datasets/fastq-qc-status';
import { EMPTY, forkJoin, Observable, of } from 'rxjs';
import { IBulkUpdateResponse, IBulkUpdateFailure } from '../../model/v2-api/v2-api-wrappers';
import { isNullOrUndefined } from 'util';
import { BasespaceService, V2Dataset } from '@bssh/ng-sdk';
import { BaseService } from '../base.service';
import { catchError, map } from 'rxjs/operators';
import { ArrayUtilities } from '@app/core/utilities/array-utilities';

export interface IChangeDatasetQcService {
  changeFastqQc(fastqDatasets: IDataset[], fastqQcStatus: FastqQcStatus, comments?: string): Observable<IBulkUpdateResponse<IDataset>>;
}

@Injectable({
  providedIn: 'root'
})
export class ChangeDatasetQcService extends BaseService implements IChangeDatasetQcService {

  constructor(private basespaceApi: BasespaceService) {
    super();
  }

  /**
   * Checks if the change qc status featured is allowed on selected fastq dataset.
   * @param fastqDatasets The dataset for which the check is to be made.
  */
   public canChangeFastqQc(fastqDatasets: IDataset[]): boolean {
    return !ArrayUtilities.isNullOrEmpty(fastqDatasets) && fastqDatasets.length > 0
    && ( this.areSelectionsQcCapable(fastqDatasets));
  }

  private areSelectionsQcCapable(selections: IDataset[]) {

    if (ArrayUtilities.isNullOrEmpty(selections)) {
      return false;
    }
    return selections.every((item) => {
      return !isNullOrUndefined(item.QcStatus);
    });
  }

  public changeFastqQc(fastqDatasets: IDataset[], fastqQcStatus: FastqQcStatus, comments?: string): Observable<IBulkUpdateResponse<IDataset>> {
    const datasetResponse: IBulkUpdateResponse<IDataset> = {
      SuccessItems: [],
      TotalSuccessCount: 0,
      FailureItems: [],
      TotalFailureCount: 0
    };

    const postData = {
      QcStatus: fastqQcStatus,
      ...!isNullOrUndefined(comments) && {Comment: comments}
    };

    return forkJoin(
      fastqDatasets.map((dataset: IDataset) => {
        return this.basespaceApi.PostV2DatasetsId({id: dataset.Id, payload: postData}).
          pipe(
            catchError(error => {
              const failureObject: IBulkUpdateFailure<IDataset> = {
                Id: dataset.Id,
                ErrorMessage: error.error.ErrorMessage,
                ErrorCode: error.status
              };
              datasetResponse.FailureItems.push(failureObject);
              datasetResponse.TotalFailureCount++;
              return of(undefined);
            }),
          ).pipe(
            map((response: V2Dataset) => {
              if (response) {
                datasetResponse.SuccessItems.push(response);
                datasetResponse.TotalSuccessCount++;
              }
              return EMPTY ; // as nothing needs to be returned from this observable, but laneResponse needs to returned
            })
          );
      })
    ).pipe(map((response: any) => {
      return datasetResponse;
    }));
  }
}
